const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";
import * as types from "./mutation_types";

export const createFacture = ({ commit }, id) => {
  commit(types.FACTURE_SHOW_TOGGLE_LOADING);
  axios
    .get(URL_BACKEND + "api-safir/create/" + id + "/")
    .then((response) => {
      commit(types.FACTURE_SHOW_TOGGLE_LOADING);
      if ("nok" in response.data) {
        commit(types.FACTURE_SHOW_SET_ERROR, response.data.nok);
      } else {
        commit(types.FACTURE_SHOW_SET_RETRIEVED, response.data);
      }
    })
    .catch((e) => {
      commit(types.FACTURE_SHOW_TOGGLE_LOADING);
      commit(types.FACTURE_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FACTURE_SHOW_RESET);
};
